import { Badge } from '@/shared/components/ui/Badge';
import { daysBetween } from '@/shared/utils/dateUtils';

interface AgingBadgeProps {
  /** The ordered_date in YYYY-MM-DD format */
  orderedDate: string;
  /** Optional custom thresholds (defaults: neutral ≤7, yellow ≤14, red >14) */
  neutralMax?: number;
  yellowMax?: number;
}

/**
 * AgingBadge - Shows days since ordered with color-coded severity
 *
 * Color coding:
 * - Neutral (gray): 0-7 days
 * - Yellow: 7-14 days
 * - Red: 14+ days
 */
export function AgingBadge({
  orderedDate,
  neutralMax = 7,
  yellowMax = 14,
}: AgingBadgeProps) {
  const daysAgo = daysBetween(orderedDate);

  // Determine variant based on age
  let variant: 'neutral' | 'warning' | 'danger' = 'neutral';
  if (daysAgo > yellowMax) {
    variant = 'danger';
  } else if (daysAgo > neutralMax) {
    variant = 'warning';
  }

  const label = daysAgo === 0 ? 'Today' : daysAgo === 1 ? '1 day' : `${daysAgo} days`;

  return (
    <Badge variant={variant} size="sm" title={`Ordered ${label} ago`}>
      {label}
    </Badge>
  );
}
